import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-brightness-auto",
  templateUrl: "./med-icon-brightness-auto.component.html",
})
export class MedIconBrightnessAutoComponent extends SvgMixinComponent {}
